import { TicketIcon } from 'lucide-react'
import { FileExportModalMode } from './file-modal'
import RadioButton from 'lib/components/radio-button/radio-button'
import CurrentAsset from './current-asset-screen'
import Modal from 'lib/components/modals/modal'
import { useState } from 'react'
import { useFilesContext } from '../files-context'
import Button from 'components/core/button'
const AddToScreen = () => {
  const { setMode } = useFilesContext()

  const [type, setType] = useState<FileExportModalMode | null>(FileExportModalMode.REQUEST)

  return (
    <>
      <Modal.Header className="tw-font-bold">
        Add to...
        <div className="tw-text-sm tw-font-normal">Select where you&apos;d like to add these assets</div>
      </Modal.Header>
      <Modal.Body
        className="tw-mt-4 tw-flex tw-flex-col tw-gap-2 tw-text-neutral-800"
        setOpen={() => setMode(null)}
        closeButton
      >
        <CurrentAsset />
        <RadioButton
          label="Request"
          description="Add selected asset to request(s)"
          onClick={() => setType(FileExportModalMode.REQUEST)}
          selected={type === FileExportModalMode.REQUEST}
          Icon={TicketIcon}
        />
        {/* <RadioButton
          label="Project"
          description="Add selected asset to project(s)"
          onClick={() => setType(FileExportModalMode.PROJECT)}
          selected={type === FileExportModalMode.PROJECT}
          Icon={FoldersIcon}
        /> */}
        {/* <RadioButton
          label="Brand"
          description="Add selected asset to brand(s)"
          onClick={() => setType(FileExportModalMode.BRAND)}
          selected={type === FileExportModalMode.BRAND}
          Icon={PaletteIcon}
        /> */}

        <Button
          className="tw-mt-2 tw-max-w-fit tw-self-end"
          color="purple"
          onClick={() => {
            setMode(type)
          }}
          disabled={!type}
        >
          Next
        </Button>
      </Modal.Body>
    </>
  )
}

export default AddToScreen
